<template>
  <with-loader id="empty-view" :loading="isLoading" class="flex flex-col" use-as-overlay>
    <img :src="imagePath[imageName]" alt="empty" class="mx-auto mt-auto">
    <span class="mx-auto mb-auto mt-8 text-gray text-center">{{ text }}</span>
    <div class="mt-8 flex justify-center">
      <slot/>
    </div>
  </with-loader>
</template>

<script>
import editorEmptyImage from '@/assets/images/editor_empty.svg'
import noConversationsImage from '@/assets/images/no_conversations.svg'
import variablesEmptyImage from '@/assets/images/variables_empty.svg'

import WithLoader from '@/components/common/WithLoader'

export default {
  components: { WithLoader },

  props: {
    text: {
      type: String,
      required: true
    },
    forEditor: {
      type: Boolean,
      default: true
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    imageName: {
      type: String,
      default: 'editorEmptyImage'
    }
  },

  computed: {
    imagePath() {
      return {
        editorEmptyImage: editorEmptyImage,
        noConversationsImage: noConversationsImage,
        variablesEmpty: variablesEmptyImage
      }
    }
  }
}
</script>
